// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1K2q0","rootSmall":"AddTileButton_rootSmall__1qXmv"};